import React from 'react';
import { Nen3140Score } from '../../../../common/src/domain/customInspectionTypes/nen3140/Nen3140Score';
import { nen3140ScoreToColorCode } from '../../../../common/src/domain/customInspectionTypes/nen3140/nen3140ScoreToColorCode';
import { conditionScoreToScore } from '../../../../common/src/domain/customInspectionTypes/nen3140/nen3140Settings';

// eslint-disable-next-line @typescript-eslint/naming-convention
const Nen3140ConditionScoreLabel = React.memo((props: { conditionScore: number | undefined | null | string }) => {
    if (props.conditionScore === null || props.conditionScore === undefined) {
        return null;
    }
    const nen3140Score = conditionScoreToScore(props.conditionScore) as Nen3140Score;
    const colorCode = nen3140ScoreToColorCode(nen3140Score);

    return (
        <span className="label p5 fs11" style={{ backgroundColor: colorCode }}>
            {nen3140Score}
        </span>
    );
});

Nen3140ConditionScoreLabel.displayName = 'Nen3140ConditionScoreLabel';
export { Nen3140ConditionScoreLabel };
